import { Controller } from '@hotwired/stimulus';

// The one administrative-action modal on a Goals v3 page (Mark as Met,
// Mark as Discontinued, Revert to Active, Delete). Every goal row used to
// render its own modals, two per row with a form each; now a row's menu
// items carry the action as data attributes and this controller, mounted
// on the single modal, listens for those triggers anywhere on the page (the
// roster region is swapped by XHR, so the triggers and the modal share no
// ancestor), fills the form from the trigger, and shows it.
//
// Trigger: any element with data-gv3-action-trigger and
//   data-gv3-action-url          the PATCH endpoint
//   data-gv3-action-title        the modal title
//   data-gv3-action-body         the action's explanation (optional)
//   data-gv3-action-submit-label the primary button text
//   data-gv3-action-submit-class the primary button's color class
//   data-gv3-action-placeholder  the reason textarea's hint
export default class extends Controller {
  static targets = ['form', 'title', 'body', 'submit', 'reason'];

  connect() {
    this.onDocumentClick = (event) => {
      const trigger = event.target.closest('[data-gv3-action-trigger]');
      if (!trigger) return;
      event.preventDefault();
      this.open(trigger);
    };
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnect() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  open(trigger) {
    const data = trigger.dataset;
    this.formTarget.setAttribute('action', data.gv3ActionUrl || '#');
    this.titleTarget.textContent = data.gv3ActionTitle || '';
    this.bodyTarget.textContent = data.gv3ActionBody || '';
    this.bodyTarget.hidden = !data.gv3ActionBody;
    this.submitTarget.value = data.gv3ActionSubmitLabel || 'Confirm';
    this.submitTarget.dataset.disableWith = this.submitTarget.value;
    this.submitTarget.className = `btn btn-sm ${data.gv3ActionSubmitClass || 'btn-primary'}`;
    this.reasonTarget.value = '';
    this.reasonTarget.placeholder = data.gv3ActionPlaceholder || '';
    this.show();
  }

  show() {
    const $ = window.jQuery || window.$;
    if ($ && $.fn && $.fn.modal) {
      $(this.element).one('shown.bs.modal', () => this.reasonTarget.focus());
      $(this.element).modal('show');
    } else {
      this.element.classList.add('show');
      this.element.style.display = 'block';
      this.reasonTarget.focus();
    }
  }
}
